<template>
  <div class="codeDiff-wrapper">
    <!-- <button @click="editor()">走你</button> -->
    <!-- 代码版本，差异对比 对话框内容 -->
    <el-dialog
      :modal="false"
      title="差异对比"
      :visible.sync="editorDialog"
      class="history"
      width="100%"
    >
      <section v-if="editorDialog" class="c_h c-flex c_flex_col">
        <!-- v-if="leftVersion !== null && rightVersion !== null" -->
        <div class="c-p-10" style="padding-top:0 !important;">
          【注】左侧版本号为{{ leftVersion }}，右侧为{{ rightVersion }}
        </div>
        <div id="codeDiffView" class="c_h"></div>
      </section>
    </el-dialog>
  </div>
</template>
<script>
// 代码对比插件
import CodeMirror from 'codemirror';
import 'codemirror/lib/codemirror.css';
import 'codemirror/addon/merge/merge.js';
import 'codemirror/addon/merge/merge.css';
import DiffMatchPatch from 'diff-match-patch';
window.diff_match_patch = DiffMatchPatch;
window.DIFF_DELETE = -1;
window.DIFF_INSERT = 1;
window.DIFF_EQUAL = 0;

export default {
  name: 'codeDiff',
  props: {
    //左侧代码
    oldStr: {
      type: String,
      default: null
    },
    //右侧代码
    newStr: {
      type: String,
      default: null
    },
    //左侧版本号
    leftVersion: {
      type: Number,
      default: null
    },
    //右侧版本号
    rightVersion: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      editorDialog: false
    };
  },
  mounted() {
    this.editor();
  },
  methods: {
    // json对比
    initUI(value, orig) {
      if (value == null) return;
      const target = document.getElementById('codeDiffView');
      target.innerHTML = '';
      CodeMirror.MergeView(target, {
        value: value, // 上次内容
        origLeft: null,
        orig: orig, // 本次内容
        lineNumbers: true, // 显示行号
        mode: '',
        highlightDifferences: true,
        foldGutter: true,
        lineWrapping: true,
        styleActiveLine: true,
        matchBrackets: true,
        connect: 'align',
        readOnly: true // 只读 不可修改
      });
    },
    /** 按钮操作 */
    editor() {
      this.editorDialog = true;
      // 初始化版本差异
      this.$nextTick(() => {
        var a = this.oldStr; // 旧版本
        var b = this.newStr; // 新版本
        this.initUI(a, b);
      });
    }
  }
};
</script>
<style>
.codeDiff-wrapper .el-dialog {
  height: 100%;
}
.codeDiff-wrapper .codeDiffView {
  width: 100%;
  height: 100%;
}
.CodeMirror-merge,
.CodeMirror-merge .CodeMirror {
  min-height: 100% !important;
}

.CodeMirror-merge-2pane .CodeMirror-merge-pane {
  height: 100%;
}
</style>
